module.exports = __webpack_public_path__ + "157e1c0f4817d4bf573e00ef0a77a639.svg";